import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CustomPlaceholder } from '@yme/atoms/custom-placeholder';
import { Gallery as GalleryAtom, useGalleryContext } from '@yme/atoms/gallery';
import { Col, Container, Row } from '@yme/atoms/grid';
import { IndentWrapper } from '@yme/components/Separator';
import { useIsShowCustomPlaceholder } from '@yme/hooks/index';
import { getRTL } from '@yme/selectors/common';
import { getFullImagesList, getIsLoadedProductDetails } from '@yme/selectors/products';
import { HeadingLevel2 } from '@yme/tokens/typography';
import { getYoutubeAccessoriesIdList } from '../ProductDetailsPage/components/ProductVideo/selectors';
import { AccessoriesGalleryContext } from './AccessoriesGalleryContext';
import { AccessoriesGallerySkeleton } from './AccessoriesGallerySkeleton';
import { GALLERY_CONFIG } from './constants';
import { prepareGalleryData } from './helpers';
import { HeaderStyled } from './styled';
export function AccessoriesGallery({ isRemoveBottomIndent, title, isInEditor, }) {
    const galleryContext = useGalleryContext();
    const youTubeIdList = useSelector(getYoutubeAccessoriesIdList);
    const isRightToLeft = useSelector(getRTL);
    const isLoadedProductDetails = useSelector(getIsLoadedProductDetails);
    const fullImagesList = useSelector(getFullImagesList);
    const { setGalleryData } = galleryContext;
    const isShowCustomPlaceholder = useIsShowCustomPlaceholder();
    const items = useMemo(() => prepareGalleryData(youTubeIdList, fullImagesList), [youTubeIdList, fullImagesList]);
    useEffect(() => {
        setGalleryData(items);
    }, [items, setGalleryData]);
    if (!isLoadedProductDetails && !isInEditor) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(AccessoriesGallerySkeleton, null)));
    }
    if (isInEditor && isShowCustomPlaceholder && (!items.imagesList || !items.imagesList.length)) {
        return React.createElement(CustomPlaceholder, { title: "AccessoriesGallery" });
    }
    if (!items.imagesList || !items.imagesList.length) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, null,
            title && (React.createElement(Row, { justifyContent: "flex-start" },
                React.createElement(Col, null,
                    React.createElement(HeaderStyled, { isRightToLeft: isRightToLeft },
                        React.createElement(HeadingLevel2, null, title))))),
            React.createElement(Row, { justifyContent: "center" },
                React.createElement(Col, { lg: 8, md: 8 },
                    React.createElement(AccessoriesGalleryContext.Provider, { value: galleryContext },
                        React.createElement(GalleryAtom, { config: GALLERY_CONFIG, context: AccessoriesGalleryContext })))))));
}
AccessoriesGallery.displayName = 'AccessoriesGallery_AEMComponent';
